import request from './request'
export function chats(data, projectId) {
  return request({
    url: `/${projectId}/chats`,
    method: 'post',
    data
  })
}

export function getChats(params, conversationId, projectId) {
  return request({
    url: `/${projectId}/chats/${conversationId}`,
    method: 'get',
    params
  })
}

export function getUserHistoryChats(projectId,) {
  const end = Math.floor(new Date()/ 1000)
  // setting 30 days
  const start = end - (30 * 24 * 60 * 60) // day - hour - min - sec
  const params = {
    page: 1,
    per_page: 99999,
    start_at: start,
    end_at: end,
  }


  return request({
    url: `/${projectId}/chats/history`,
    method: 'get',
    params
  })
}


export function sessionOver(data, projectId) {
  return request({
    url: `/${projectId}/chats/session_over`,
    method: 'put',
    data
  })
}

// bulletin
export function getAnnouncement(projectId) {
  return request({
    url: `/${projectId}/chats/announcement`,
    method: 'get'
  })
}


// call human status
export function changeCallHumanStatus(data ,projectId) {
  return request({
    url: `/${projectId}/chats/cancel_call_human`,
    method: 'put',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/chat.js